import { render, staticRenderFns } from "./InputTextProjectAreaItem.vue?vue&type=template&id=7df7f8cf"
import script from "./InputTextProjectAreaItem.vue?vue&type=script&lang=js"
export * from "./InputTextProjectAreaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports